import * as React from "react"
import * as RouterDom from "react-router-dom"

export * from "react-router-dom"

export const Link = React.forwardRef<HTMLAnchorElement, React.ComponentProps<typeof RouterDom.Link>>(
  function Link({ to, ...props }, ref) {
    return <RouterDom.Link ref={ref} to={to} {...props} />
  },
)

export const NavLink = React.forwardRef<HTMLAnchorElement, React.ComponentProps<typeof RouterDom.NavLink>>(
  function NavLink({ to, ...props }, ref) {
    return <RouterDom.NavLink ref={ref} to={to} {...props} />
  },
)

export function Navigate({ to, ...props }: React.ComponentProps<typeof RouterDom.Navigate>) {
  return <RouterDom.Navigate to={to} {...props} />
}

export function useNavigate(): ReturnType<typeof RouterDom.useNavigate> {
  return RouterDom.useNavigate()
}
